import React from 'react'
import ProcessContainer from '../../containers/admin_portal/process';

const ProcessPage = () => {
  return <ProcessContainer/>
}

export default ProcessPage;
